var _path, _path2, _path3;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgAngola(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 30,
    height: 24,
    viewBox: "0 0 30 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#000",
    d: "M0 24h30V0H0z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#bc2833",
    d: "M30 0H0v12h30z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "#ffcb00",
    d: "M11.6 10.6c.15.9.98 1.6 1.92 2.34l8.83 6.8c.36.28.43.68.19.96l-.04.03a.4.4 0 0 1-.33.1c-.54-.07-.56-.54-.7-.64l-1.52-1.05-.81-.55-6.47-4.15c-1.85-1.16-1.78-2.07-1.4-3.05zm-2.27 4.94a6.3 6.3 0 0 0 6.23.96l1.06.64c-.1.1-.4.25-.47.28l.17.66c-.4.14-.85.33-1.3.42l-.27-.67q-.64.15-1.29.15l-.09.7c-.4-.04-.9 0-1.36-.11v-.7a8 8 0 0 1-1.2-.3l-.33.6-.47-.2q-.38-.15-.73-.36l.25-.66a6 6 0 0 1-.86-.57zM16.05 3.8l.37-.61.61.29.6.32-.29.66c.37.24.82.6 1.06.89l.55-.43.47.5q.23.24.43.51l-.5.52c.32.47.45.69.68 1.23l.7-.16.18.52q.16.42.23.82l-.66.26c.07.28.15.75.17 1.18v.31l.7.1-.05.66q-.03.34-.09.67h-.72c-.1.44-.23.98-.4 1.39l.6.35-.28.61-.34.6-.66-.28a8 8 0 0 1-.84 1.04l.43.56-.34.32-1.41-1.1a6.4 6.4 0 0 0 2.35-4.92 6.3 6.3 0 0 0-5.01-6.17l.22-1.02c.4.08.86.25 1.24.38m-1.6 1.9L15 7.4h1.8l-1.45 1.07.56 1.72-1.47-1.05L13 10.2l.56-1.72L12.1 7.4h1.79z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAngola);
export default __webpack_public_path__ + "static/media/angola.58dc59e6b513711b3ca693cc91c8bfca.svg";
export { ForwardRef as ReactComponent };